export default __webpack_public_path__ + "static/media/36I-102707_-17661_0.6cb3fe6e.jpg";